import React, { createContext, useState } from 'react';
import axios from 'axios';

export const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
  const [titles, setTitles] = useState([]);
  const [sideChat, setSideChat] = useState([]);
  const [sideId, setSideId] = useState(localStorage.getItem('sessionId') || '');
  const [sessionId, setSessionId] = useState(localStorage.getItem("sessionId") || null);
  const loadChatHistory = async (user_id) => {
    const URL = `https://gemxbackend.onrender.com/conversation/chatRetrieve/${user_id}`;
    try {
      const response = await axios(URL);

      if (response.data) {
        const allChats = response.data;
        setTitles(allChats);
      }
    } catch (error) {
      console.error("Error loading chat history:", error);
    }
  };

  const startNewSession = async () => {
    try {

      const response = await axios.post(
        "https://gemxbackend.onrender.com/start-session"
      );
      const newSessionId = response.data.sessionId;
      setSessionId(newSessionId);
      localStorage.setItem("sessionId", newSessionId);
    } catch (error) {
      console.error("Error starting new session:", error);
    }
  };

  return (
    <ChatContext.Provider value={{ titles, setTitles, sideChat, setSideChat, sideId, setSideId , sessionId,setSessionId, loadChatHistory,startNewSession}}>
      {children}
    </ChatContext.Provider>
  );
};
